import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { memberApi } from '@formosa/shared/api/member';
import { resolveSafeUserVisibleError } from '@formosa/shared/i18n/safeUserVisibleError';
import { formatDateTime } from '@formosa/shared/utils/formatDateTime';
import { resolveMemberMediaUrl } from '@formosa/shared/utils/mediaUrl';
import { resolveNewsApiLang } from '@formosa/shared/utils/newsLang';
import { useTravelTranslation } from '../../app/TravelLocaleContext';
import { ErrorState, LoadingState } from '../../components/ui';
import './member-content-notices.css';

export default function SiteMailDetailPage() {
  const { mailId } = useParams();
  const { locale } = useTravelTranslation();
  const [phase, setPhase] = useState('loading');
  const [error, setError] = useState('');
  const [detail, setDetail] = useState(null);
  const [reloadToken, setReloadToken] = useState(0);

  useEffect(() => {
    let cancelled = false;
    async function load() {
      setPhase('loading');
      setError('');
      try {
        const data = await memberApi.inboxDetail(mailId, {
          lang: resolveNewsApiLang(locale),
        });
        if (!cancelled) {
          setDetail(data || null);
          setPhase('ready');
        }
      } catch (cause) {
        if (!cancelled) {
          setError(resolveSafeUserVisibleError(cause, () => '無法載入站內信。', 'travel.common.loadFailed'));
          setPhase('error');
        }
      }
    }
    load();
    return () => {
      cancelled = true;
    };
  }, [mailId, locale, reloadToken]);

  return (
    <main className="member-content-notices" data-testid="site-mail-detail-page">
      <Link to="/site-mail" className="member-content-notices__back">
        返回站內信列表
      </Link>
      {phase === 'loading' ? <LoadingState label="載入站內信…" /> : null}
      {phase === 'error' ? (
        <ErrorState
          title="無法載入站內信"
          description={error}
          retryable
          onRetry={() => setReloadToken((value) => value + 1)}
          retryLabel="重新載入"
        />
      ) : null}
      {phase === 'ready' && detail ? (
        <article className="member-content-notices__detail">
          <h1>{detail.title || '站內信'}</h1>
          {detail.createTime ? (
            <time dateTime={detail.createTime}>{formatDateTime(detail.createTime)}</time>
          ) : null}
          {detail.imgUrl ? (
            <img src={resolveMemberMediaUrl(detail.imgUrl)} alt="" />
          ) : null}
          {detail.content ? (
            <div
              className="member-content-notices__html"
              dangerouslySetInnerHTML={{ __html: detail.content }}
            />
          ) : null}
        </article>
      ) : null}
    </main>
  );
}
